module.exports = __webpack_public_path__ + "static/media/Rotate.560207e3.svg";